import { type SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';

import { autotagsSaga } from './sagas/autotags';
import { cannedResponsesSagas } from './sagas/sagas';

export function* cannedResponsesWithAutotagsSagas(): SagaIterator {
  yield all([fork(cannedResponsesSagas), fork(autotagsSaga)]);
}
